/**
 * Artcore Storefront — UI runtime (reveal, cards, header polish)
 */
(function () {
  'use strict';

  const ROOT_SEL = '.artcore-storefront';

  function initReveal() {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    const nodes = root.querySelectorAll('.artcore-reveal:not(.is-visible)');
    if (!nodes.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      nodes.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    nodes.forEach((el) => io.observe(el));
  }

  function initProductCards() {
    document.querySelectorAll('.artcore-product-card').forEach((card) => {
      if (card.dataset.acInit) return;
      card.dataset.acInit = 'true';
      card.addEventListener('mouseenter', () => card.classList.add('is-hovered'));
      card.addEventListener('mouseleave', () => card.classList.remove('is-hovered'));
    });
  }

  function initHeader() {
    const header = document.querySelector('.artcore-site-header');
    if (!header) return;
    header.setAttribute('data-ac-header', 'true');
  }

  function init() {
    initReveal();
    initProductCards();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.ArtcoreStorefrontInit = init;
})();
